import { APIClient } from '..'
import type { ReviewSentence } from 'src/biz_spa/types'
import type { ReadSentenceRequestParams, ReadSentenceRequestParamsServer } from './types'

export class AnalysisAPIClient extends APIClient {
  constructor() {
    super()
  }

  async readSentences(companyUuid: string, params: ReadSentenceRequestParams): Promise<ReviewSentence[]> {
    const response = await this.post<ReadSentenceRequestParamsServer, { data: ReviewSentence[] }>(`/api/companies/${companyUuid}/reviews/sentences.json`, {
      ...params,
      startDate: params.startDate.format('YYYY-MM-DD'),
      endDate: params.endDate.format('YYYY-MM-DD'),
    })
    return response.data.data
  }
}

export type { ReadSentenceRequestParams } from './types'
